import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingCropFertilizersMineralsByPrimaryDataId, getFootprintingCropFertilizersMineralsByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP_FERTILIZERS_MINERAL } from "consts";

export const useGetFootprintingCropFertilizersMineral = (primaryDataId: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getFootprintingCropFertilizersMineralsByPrimaryDataIdAdmin : getFootprintingCropFertilizersMineralsByPrimaryDataId;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_CROP_FERTILIZERS_MINERAL, primaryDataId],
      queryFn: () => queryFn(primaryDataId),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
